import {
  Button,
  Container,
  Form,
  InputGroup,
  Nav,
  Navbar,
} from "react-bootstrap";
import "../css/header.css";
import { Link, useLocation, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../services/auth";

const Header = () => {
  const { isEnglish, toggleLanguage } = useContext(AuthContext);
  const [isHome, setIsHome] = useState(true);
  const [reserch, setReserch] = useState(false);
  const location = useLocation();
  const { categoryCompositions, slugMusic } = useParams();
  let flagSroll = true;
  document.body.classList.remove("visualized");
  const Scrolled = () => {
    const navbar = document.getElementById("nav");
    if (!navbar) return;
    let srolsY = window.scrollY;
    let srolsX = window.innerWidth;
    if (srolsX > 1199) {
      if (srolsY > 100 && flagSroll) {
        flagSroll = false;
        navbar.classList.replace("color-nav", "color-nav-scrolled");
      } else if (srolsY < 100 && !flagSroll) {
        navbar.classList.replace("color-nav-scrolled", "color-nav");
        flagSroll = true;
      }
    } else if (!flagSroll) {
      navbar.classList.replace("color-nav-scrolled", "color-nav");
      flagSroll = true;
    }
    if (
      location.pathname === "/" ||
      location.pathname === "/bio" ||
      location.pathname === `/compositions/${encodeURIComponent(categoryCompositions)}/${encodeURIComponent(slugMusic)}`
    ) {
      navbar.classList.remove("header_white");
    } else {
      navbar.classList.add("header_white");
    }
    if (
      location.pathname === "/" &&
      !navbar.classList.contains("color-nav-scrolled") &&
      srolsX > 1199
    ) {
      setIsHome(false);
    } else {
      if (!isHome) setIsHome(true);
    }
  };

  useEffect(() => {
    Scrolled();
  }, [location]);

  window.addEventListener("resize", Scrolled);
  window.addEventListener("scroll", Scrolled);

  return (
    <Container
      fluid
      className="position-fixed top-0 end-0 w-100 p-0 container_navbar"
    >
      <Navbar
        id="nav"
        expand="xl"
        className="  w-100 p-3 color-nav text-center"
      >
        <Navbar.Brand>
          <Link to={"/"} className="text-decoration-none navbar-brand">
            <h3 className="m-0 title_data">{isHome && "ROSELLA CLEMENTI"}</h3>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="custom-toggle  ms-auto text-white"
        />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="nav-body text-white text-center ms-auto">
            <Link className="nav-link" to={"/"}>
              HOME
            </Link>
            <Link className="nav-link" to={"/bio"}>
              BIO
            </Link>
            <Link className="nav-link" to={"/compositions"}>
              {isEnglish ? "COMPOSITIONS" : "COMPOSIZIONI"}
            </Link>
            <Link className="nav-link" to={"/art-direction"}>
              {isEnglish ? "ARTISTIC DIRECTION" : "DIREZIONE ARTISTICA"}
            </Link>
            <Link className="nav-link" to={"/portfolio"}>
              {isEnglish ? "PORTFOLIO" : "PORTFOLIO"}
            </Link>
            <Link className="nav-link" to={"/gallery"}>
              {isEnglish ? "GALLERY" : "GALLERIA"}
            </Link>
            <Link className="nav-link" to={"/credits"}>
              CREDITS
            </Link>
            <Link className="nav-link" to={"/contacts"}>
              {isEnglish ? "CONTACTS" : "CONTATTI"}
            </Link>
            <Link className="nav-link" to={"/news"}>
              NEWS
            </Link>
            <Link
              to={location.pathname}
              className="nav-link nav-link-lenguage"
              onClick={toggleLanguage}
            >
              {isEnglish ? "ITALIANO" : "ENGLISH"}
            </Link>
            <Link className="nav-link" to={"/search"}>
              
              <span className="search d-inline-block d-lg-none" >{isEnglish ? "CERCA" : "SEARCH"}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-search pb-1"
                viewBox="0 0 16 16"
              >
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
};
export default Header;
